import React from 'react';
import PropTypes from 'prop-types';

import Brand from 'models/brand';

const propTypes = {
  brand: PropTypes.instanceOf(Brand).isRequired,
};

const LegalPageHeader = ({ brand }) => (
  <div className="background-image-smooth-p-gradient padding-top-xs-80 padding-top-md-120 margin-bottom-xs-40">
    <div className="container text-center">
      <a href="/" className="hidden-xs hidden-sm header-logo-dark">
        <img src={brand.logoLightURL} alt={brand.displayName} />
      </a>
      <div className="row visible-xs visible-sm">
        <div className="col-sm-6 col-sm-offset-3 col-xs-8 col-xs-offset-2 margin-top-negative-60">
          <a href="/">
            <picture>
              <img src={brand.logoLightURL} alt={brand.displayName} />
            </picture>
          </a>
        </div>
      </div>
      <div className="row">
        <div className="col-xs-12 margin-top-sm-40 margin-top-xs-20 text-size-sm-72 text-size-xs-36 text-weight-black text-color-dark-slate margin-top-60 text-align-center line-height-full">
          TERMS OF SERVICE
          <div className="text-color-blue">& PRIVACY POLICY</div>
        </div>
      </div>
    </div>
  </div>
);

LegalPageHeader.propTypes = propTypes;

export default LegalPageHeader;
